<div class="row">
  <div class="col-xl-12">
    <div class="card" style="margin-bottom: 150px;">


      <!-- MENSAJE FINAL DE GUARDADO -->
      <div class="text-center" *ngIf="finalSaveMessage">
        <div class="mt-4">
          <div class="logout-checkmark">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#4bd396" stroke-width="6" stroke-miterlimit="10" cx="65.1"
                cy="65.1" r="62.1" />
              <polyline class="path check" fill="none" stroke="#4bd396" stroke-width="6" stroke-linecap="round"
                stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
            </svg>
          </div>
        </div>

        <h3 i18n>Datos de árbitro guardados</h3>


        <p class="text-muted" i18n *ngIf="!datosCompletos">No olvide rellenar los campos marcados con (*) para completar
          su perfil.</p>
        <div class="row mt-3" footerLink>
          <div class="col-12 text-center">
          </div> <!-- end col -->
        </div>
      </div>
      <!-- FIN FINAL DE GUARDADO -->


      <div class="card-body" *ngIf="!finalSaveMessage">

        <h4 class="header-title mb-3" style="display: flex; justify-content: space-between; width: 100%;"><span
            i18n>Datos de
            Árbitro</span><span *ngIf="isSaving" class="saving-indicator" i18n>Guardando...</span></h4>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>

        <form [formGroup]="basicWizardForm" #basicForm="ngForm" *ngIf="loaded">
          <div id="basicwizard">
            <!--<ul ngbNav #basicWizard="ngbNav" [(activeId)]="activeWizard1"
              class="nav-pills bg-light nav-justified form-wizard-header mb-4">-->
            <ul ngbNav #basicWizard="ngbNav" [(activeId)]="activeWizard1"
              class="nav-pills bg-light nav-justified form-wizard-header mb-4" (navChange)="onNavChange($event)">
              <li [ngbNavItem]="1">
                <a ngbNavLink class="rounded-0 pt-2 pb-2">
                  <i class="mdi mdi-account-circle me-1"></i>
                  <span class="d-none d-sm-inline" i18n>Datos Personales</span>
                </a>
                <ng-template ngbNavContent>

                  <div class="row" formGroupName="datos">

                    <!-- DOS FILAS INCICIALES -->
                    <div class="row">

                      <!-- Columna para el avatar -->
                      <div class="col-md-2">
                        <img *ngIf="avatarUrl" [src]="avatarUrl" class="rounded-circle"
                          style="width: 130px; height: 130px; object-fit: cover;">

                        <!-- El input de archivo está oculto -->
                        <input type="file" id="inputAvatar" (change)="onFileChange($event)" name="avatar"
                          style="display: none;">

                        <!-- Botón que el usuario hace clic para cambiar la foto -->
                        <button class="btn btn-primary mt-3 mb-3" (click)="triggerFileInput()"><span i18n>Cambiar mi
                            foto</span></button>
                      </div>

                      <!-- Columnas para los campos, organizados en dos filas -->
                      <div class="col-md-10">
                        <div class="row">
                          <div class="col-md-6">
                            <label for="inputApellidos" class="form-label" i18n>Apellidos (*)</label>
                            <input type="text" class="form-control" id="inputApellidos"
                              i18n-placeholder="@@apellidosPlaceholder" placeholder="Apellidos"
                              formControlName="apellidos" maxlength="100">
                          </div>
                          <div class="col-md-6">
                            <label for="inputNombre" class="form-label" i18n>Nombre (*)</label>
                            <input type="text" class="form-control" id="inputNombre"
                              i18n-placeholder="@@nombrePlaceholder" placeholder="Nombre" formControlName="nombre"
                              maxlength="100">
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-3 mb-3">
                            <label for="inputGenero" class="form-label" i18n>Género (*)</label>
                            <select class="form-select" id="inputGenero" formControlName="genero">
                              <option value="MASCULINO" i18n>Masculino</option>
                              <option value="FEMENINO" i18n>Femenino</option>
                              <option value="PREFIERO_NO_CONTESTAR" i18n>Prefiero no contestar</option>
                            </select>
                          </div>
                          <div class="col-md-3 mb-3">
                            <label for="inputFechaNacimiento" class="form-label" i18n>Fecha de Nacimiento (*)</label>
                            <input class="form-control" id="inputFechaNacimiento" type="date"
                              formControlName="fecha_nacimiento">
                          </div>
                          <div class="col-md-4 mb-3">
                            <label for="inputEmail" class="form-label" i18n>Email (*)</label>
                            <input type="email" class="form-control" id="inputEmail"
                              i18n-placeholder="@@emailPlaceholder" placeholder="Email" [formControl]="emailControl">
                          </div>

                          <div class="col-md-2 d-flex align-items-end mb-3">
                            <button class="btn btn-primary w-100" (click)="triggerCambiarEmail()">
                              <span i18n>Cambiar email</span>
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                    <!-- FIN DOS FILAS INCICIALES -->

                    <div class="col-md-4 mb-3">
                      <label for="inputTitulo" class="form-label" i18n>Título (e.g. Prof. / Dr. / Sr. / Sra.)</label>
                      <input type="text" class="form-control" id="inputTitulo" i18n-placeholder="@@tituloPlaceholder"
                        placeholder="Título" formControlName="titulo" maxlength="50">
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="inputInstitucion" class="form-label" i18n>Institución</label>
                      <input type="text" class="form-control" id="inputInstitucion"
                        i18n-placeholder="@@institucionPlaceholder" placeholder="Institución"
                        formControlName="institucion">
                    </div>
                    <div class="col-md-4 mb-3">
                      <label for="inputCargo" class="form-label" i18n>Cargo</label>
                      <input type="text" class="form-control" id="inputCargo" i18n-placeholder="@@cargoPlaceholder"
                        placeholder="Cargo" formControlName="cargo">
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="inputDireccion" class="form-label" i18n>Dirección</label>
                      <input type="text" class="form-control" id="inputDireccion"
                        i18n-placeholder="@@direccionPlaceholder" placeholder="Dirección" formControlName="direccion"
                        maxlength="100">
                    </div>
                    <div class="col-md-3 mb-3">
                      <label for="inputTelefono" class="form-label" i18n>Teléfono</label>
                      <input type="text" class="form-control" id="inputTelefono"
                        i18n-placeholder="@@telefonoPlaceholder" placeholder="Teléfono" formControlName="telefono"
                        maxlength="25">
                    </div>
                    <div class="col-md-3 mb-3">
                      <label for="inputMovil" class="form-label" i18n>Móvil</label>
                      <input type="text" class="form-control" id="inputMovil" i18n-placeholder="@@movilPlaceholder"
                        placeholder="Móvil" formControlName="movil" maxlength="25">
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="inputProfesion" class="form-label" i18n>Profesión/es</label>
                      <select2 [data]="profesiones" i18n-placeholder="@@profesionesPlaceholder"
                        placeholder="Profesion/es" id="inputProfesion" multiple="true" #country2
                        formControlName="profesiones" [value]="profesionesArray">
                      </select2>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="inputProfesionOtras" class="form-label" i18n>Otras (especificar)</label>
                      <input type="text" class="form-control" id="inputProfesionOtras"
                        i18n-placeholder="@@profesionesOtrasPlaceholder" placeholder="Otras (especificar)"
                        formControlName="profesion_otras">
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="inputNacionalidad" class="form-label" i18n>Nacionalidad/es (*)</label>
                      <select2 [data]="nacionalidades" i18n-placeholder="@@nacionalidadesPlaceholder"
                        placeholder="Nacionalidad/es" id="inputNacionalidad" multiple="true" #country2
                        displaySearchStatus="always" noLabelTemplate="true" formControlName="nacionalidades"
                        [value]="nacionalidadesArray">
                      </select2>
                    </div>

                    <div class="col-md-6 mb-3" *ngIf="adminView">
                      <div class="form-check form-switch">
                        <input type="checkbox" id="es_reprensentante" class="form-check-input" name="es_reprensentante"
                          formControlName="es_representante">
                        <label class="form-check-label" for="es_reprensentante">Es Representante</label>
                      </div>
                    </div>

                  </div>
                </ng-template>
              </li>

              <li [ngbNavItem]="2">
                <a ngbNavLink class="rounded-0 pt-2 pb-2">
                  <i class="mdi mdi-badge-account me-1"></i>
                  <span class="d-none d-sm-inline" i18n>Formación</span>
                </a>
                <ng-template ngbNavContent>
                  <div class="row" formGroupName="formacion">

                    <div class="col-md-6 mb-3">
                      <label for="inputTitulos" class="form-label" i18n>Títulos académicos</label>
                      <textarea class="form-control" id="inputTitulos" rows="5"
                        i18n-placeholder="@@titulosAcademicosPlaceholder" placeholder="Títulos académicos"
                        formControlName="titulos_academicos"></textarea>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="inputExperiencia" class="form-label" i18n>Experiencia laboral</label>
                      <textarea class="form-control" id="inputExperiencia" rows="5"
                        i18n-placeholder="@@experienciaLaboralPlaceholder" placeholder="Experiencia laboral"
                        formControlName="experiencia_profesional"></textarea>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label for="inputColegiacion" class="form-label" i18n>Colegiación (*)</label>
                      <select2 [data]="colegiaciones" i18n-placeholder="@@ColegiacionesPlaceholder"
                        placeholder="Colegiación/es" id="inputColegiacion" multiple="true" #country2
                        formControlName="colegiaciones" [value]="colegiacionesArray">
                      </select2>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="inputIdiomas" class="form-label" i18n>Idioma/s (*)</label>
                      <select2 [data]="idiomas" i18n-placeholder="@@idiomasPlaceholder" placeholder="Idiomas"
                        id="inputIdiomas" multiple="true" #country2 formControlName="idiomas" [value]="idiomasArray">
                      </select2>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="inputIdiomasOtros" class="form-label" i18n>Otros Idiomas (especificar)</label>
                      <input type="text" class="form-control" id="inputIdiomasOtros"
                        i18n-placeholder="@@idiomasOtrosPlaceholder" placeholder="Otros (especificar)"
                        formControlName="idiomas_otros">
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="inputSectores" class="form-label" i18n>Sectores</label>
                      <select2 [data]="sectores" i18n-placeholder="@@sectoresPlaceholder" placeholder="Sectores"
                        id="inputSectores" multiple="true" #country2 formControlName="sectores" [value]="sectoresArray">
                      </select2>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="inputSectoresOtros" class="form-label" i18n>Otros Sectores (especificar)</label>
                      <textarea class="form-control" id="inputSectoresOtros" rows="5"
                        i18n-placeholder="@@sectoresOtrosPlaceholder" placeholder="Otros (especificar)"
                        formControlName="sectores_otros"></textarea>
                    </div>

                  </div> <!-- end row -->

                </ng-template>
              </li>
              <li [ngbNavItem]="3">
                <a ngbNavLink class="rounded-0 pt-2 pb-2">
                  <i class="mdi mdi-checkbox-marked-circle-outline me-1"></i>
                  <span class="d-none d-sm-inline" i18n>Experiencia</span>
                </a>
                <ng-template ngbNavContent>
                  <div class="row" formGroupName="experiencia">

                    <div class="col-md-12 mb-3">
                      <label for="inputTableExperiencia" class="form-label" i18n>Experiencia (nº de casos en los que ha
                        actuado)</label>
                      <table class="table" id="inputTableExperiencia">
                        <thead>
                          <tr>
                            <th class="title-categoria"></th>
                            <th class="title-categoria"></th>
                            <th class="title-categoria" i18n>Presidente del Tribunal</th>
                            <th class="title-categoria" i18n>Árbitro único</th>
                            <th class="title-categoria" i18n>Co-árbitro</th>
                            <th class="title-categoria" i18n>Letrado de parte</th>
                            <th class="title-categoria" i18n>Secretario del Tribunal</th>
                            <th class="title-categoria" i18n>Árbitro de emergencia</th>
                            <th style="width: 60px;">TOTAL</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let fila of matriz; let i = index">
                            <td class="{{ (i !== 2 && i !== 4) ? 'no-border' : '' }}">{{ experienciaFilasCategoria[i] }}
                            </td>
                            <td class="valign-center">{{ experienciaFilas[i] }}</td>
                            <td *ngFor="let dato of fila; let j = index"><input type="number" class="form-control"
                                id="i"
                                [formControlName]="getFormControlName(experienciaFilasCategoriaFormGroup[i],experienciaFilasFormGroup[i], experienciaColumnFormGroup[j])">
                            </td>
                            <td class="total"> {{ getTotal(totalesColumna, experienciaFilaFormGroup[i]) }}</td>
                          </tr>
                          <tr>
                            <td class="no-border"></td>
                            <td style="font-weight: bold;">TOTAL</td>
                            <td class="total">{{ getTotal(totalesFila,"presidente") }}</td>
                            <td class="total">{{ getTotal(totalesFila,"arbitro_unico") }}</td>
                            <td class="total">{{ getTotal(totalesFila,"coarbitro") }}</td>
                            <td class="total">{{ getTotal(totalesFila,"letrado") }}</td>
                            <td class="total">{{ getTotal(totalesFila,"secretario") }}</td>
                            <td class="total">{{ getTotal(totalesFila,"arbitro_emergencia") }}</td>
                            <td class="no-border"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-12 mb-3">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="inputCheckboxExperiencia"
                          formControlName="experiencia_cumplimentada">
                        <label class="form-check-label" for="inputCheckboxExperiencia" i18n>Declaro haber cumplimentado
                          mi
                          experiencia a la fecha del presente formulario. (*)</label>
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label for="inputSistemasJuridico" class="form-label" i18n>Sistemas jurídicos (*)</label>
                      <select2 [data]="sistemasJuridicos" i18n-placeholder="@@sistemasJuridicosPlaceholder"
                        placeholder="Sistema jurídico" id="inputSistemasJuridico" multiple="true" #country2
                        formControlName="sistemasJuridicos" [value]="sistemasJuridicosArray">
                      </select2>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="inputSistemaJuridicoOtros" class="form-label" i18n>Otros sistemas
                        (especificar)</label>
                      <input type="text" class="form-control" id="inputSistemaJuridicoOtros"
                        i18n-placeholder="@@sistemasJuridicosOtrosPlaceholder"
                        placeholder="Otros sistemas (especificar)" formControlName="sistema_juridico_otros">
                    </div>

                    <div class="col-md-12 mb-3">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="inputComunicaciones"
                          formControlName="comunicaciones_comerciales">
                        <label class="form-check-label" for="inputComunicaciones" i18n>ACEPTO recibir noticias,
                          novedades y
                          próximos eventos del Centro.</label>
                      </div>
                    </div>

                  </div> <!-- end row -->
                </ng-template>
              </li>


              <!-- Pestaña comentarios sólo para Admin-->
              <ng-container *ngIf="adminView">
                <li [ngbNavItem]="4">
                  <a ngbNavLink class="rounded-0 pt-2 pb-2">
                    <i class="mdi mdi-comment-account-outline me-1"></i>
                    <span class="d-none d-sm-inline" i18n>Comentarios</span>
                  </a>
                  <ng-template ngbNavContent>
                    <div class="row" formGroupName="comentarios">
                      <div class="col-md-12 mb-3">
                        <label for="inputComentarios" class="form-label" i18n>Comentarios internos</label>
                        <textarea class="form-control" id="inputComentarios" rows="10"
                          i18n-placeholder="@@comentariosInternosPlaceholder" placeholder="Comentarios internos"
                          formControlName="comentarios_internos"></textarea>
                      </div>

                    </div> <!-- end row -->
                  </ng-template>
                </li>
              </ng-container>


            </ul>

            <div [ngbNavOutlet]="basicWizard" class="b-0 mb-0 pt-0"></div>
            <ul class="list-inline mb-0 wizard">
              <li class="previous list-inline-item">
                <button class="btn btn-secondary" (click)="goToPreviousStep()" [disabled]="activeWizard1===1"
                  i18n>Anterior</button>
              </li>
              <li class="next list-inline-item float-end">
                <button type="button" (click)="goToNextStep()" class="btn btn-secondary" *ngIf="activeWizard1<maxtab"
                  i18n>Siguiente</button>
                <button type="button" (click)="finalSave()" class="btn btn-secondary" *ngIf="activeWizard1===maxtab"
                  i18n>Guardar</button>
              </li>
            </ul>



          </div> <!-- end #basicwizard-->
        </form>

      </div> <!-- end card-body -->
    </div> <!-- end card-->
  </div> <!-- end col -->
</div>
<!-- end row -->
